/**
 * URL-bound window param (`win`) — API mapping happens in query hooks.
 */
import { DEFAULT_WINDOW, WindowKeySchema, type WindowKey } from '@meridian/contracts';

import { useSearchEnumParam } from './use-search-enum-param';

export function useWindowParam(): {
  readonly window: WindowKey;
  readonly setWindow: (win: WindowKey) => void;
} {
  const { value, setValue } = useSearchEnumParam('win', WindowKeySchema, DEFAULT_WINDOW);
  return { window: value, setWindow: setValue };
}
